/**
 * Binds the modal toggle click.
 *
 * @usage   As close only: Add modal--toggle class to trigger.
 * @example <a href="javascript:;" class="modal--toggle">Close modal</a>
 *
 * @usage   As modal open: Add both modal--toggle class AND data-toggle-modal-id attribute to trigger.
 *          Make sure that the corresponding modal exists. ID MUST be EXACTLY the same as trigger's toggle value.
 * @example <a href="javascript:;" class="modal--toggle" data-toggle-modal-id="ID_HERE">Open a modal</a>
 */
function bindModalToggle() {
	const modalTriggers = document.getElementsByClassName( 'modal--toggle' );

	[...modalTriggers].forEach( ( element ) => {
		const modalToOpen = element.getAttribute( 'data-toggle-modal-id' );

		element.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			closeAllModals();

			if ( modalToOpen ) {
				openModal( modalToOpen );
			}
		} );
	} );
}

/**
 * Checks if any modals are open, used to check if we need to close it on document click
 *
 * @returns {boolean}
 */
function aModalIsOpen() {
	const modals = document.getElementsByClassName( 'modal' );
	let modalOpen = false;

	[...modals].forEach( ( element ) => {
		if (
			// Needs to have class open ...
			element.classList.contains( 'open' )

			// And also position left == 0, because the class does get added earlier sometimes making it unreliable
			&& element.getBoundingClientRect().left === 0
		) {
			modalOpen = true;
		}
	} );

	return modalOpen;
}

/**
 * Closes all modals in different ways, on ESC key press and if you press in the slant.
 */
function bindModalClose() {
	// Click in the padding (slant)
	document.addEventListener( 'click', ( event ) => {
		if ( aModalIsOpen() ) {
			const paths = event.composedPath();
			let isModal = false;

			if ( paths.length ) {
				[...paths].forEach( ( element ) => {
					if ( element.classList ) {
						if ( element.classList.contains( 'modal' ) ) {
							isModal = true;
						}
					}
				} );
			}

			if ( !isModal ) {
				closeAllModals();
			}
		}
	} );

	// On ESC key
	document.onkeydown = function ( evt ) {
		evt = evt || window.event;
		var isEscape = false;
		if ( 'key' in evt ) {
			isEscape = (
				evt.key === 'Escape' || evt.key === 'Esc'
			);
		} else {
			isEscape = (
				evt.keyCode === 27
			);
		}
		if ( isEscape ) {
			closeAllModals();
		}
	};
}

/**
 * Opens modal(s) based on name.
 * The name is given in the data-modal attribute of the modal.
 *
 * @param name
 */
function openModal( name ) {
	const modalList = document.querySelectorAll( '[data-modal-id="' + name + '"]' );

	if ( modalList.length ) {
		[...modalList].forEach( ( element ) => {
			element.classList.add( 'open' );
		} );
	}
}

/**
 * Closes all the modals. Gives a nice clean start to open a freshie.
 */
function closeAllModals() {
	const modals = document.getElementsByClassName( 'modal' );

	[...modals].forEach( ( element ) => {
		element.classList.remove( 'open' );
	} );
}

/**
 * Maybe opens a modal. Used when sharing, a query arg is added (id)
 *
 * @usage [URL_HERE]?mid=[MODAL_ID]
 */
function maybeOpenModal() {
	const params = new URLSearchParams( window.location.search );

	if ( params.has( 'mid' ) ) {
		const mid = params.get( 'mid' );
		openModal( mid );
	} else {
		return;
	}
}

export default {
	init() {
		bindModalToggle();
		bindModalClose();
		maybeOpenModal();
	},
};